var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[_c('vue-jitsi-meet',{ref:"jitsiRef",attrs:{"domain":"vc.mobilon.ru","options":_vm.jitsiOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }